
import Vue from 'vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Helpers from './helpers';

export default Vue.extend({
  name: 'App',
  components: {
    Header, Footer
  }
});

// Preload heavy images or gifs that are used in other pages
Helpers.preloadImages([
  "img/projects/lurking-icon.gif",
  "img/projects/phantom-squad-icon.gif",
  "img/projects/neon-escape-icon.gif",
  "img/projects/hypercasual-icon.gif",
  "img/projects/jumpy-deer-icon.png",
  "img/projects/the-gatherer-icon.gif",
  "img/projects/skyline-rider-icon.gif"
]);

